import { interpretCompanyNameError, interpretUserNameError } from "../../../validators/interpretators";
import { validators } from "../../../validators/validators";

export const validateFullName = (value) => {
    return interpretUserNameError(
        validators.ValidateUserName(value)
    )
}

export const validateEmail = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    } else if (validators.ValidateEmail(value)) {
        error = "errors.email.invalid_format"
    }

    return error;
}

export const validatePhone = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    } else if (validators.ValidatePhone(value)) {
        error = "errors.phone.invalid_format"
    }

    return error;
}

export const validateAddress = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    } else if (validators.ValidateLength(value, 2, 150)) {
        error = "errors.user_address.between_2_150"
    } else if(validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)) {
        error = "errors.user_address.only_english_letters"
    }

    return error;
}

export const validateIdentityDocumentNumber = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    } else if (validators.ValidateNumber(value)) {
        error = "errors.identity_document_number.number"
    } else if (validators.ValidateLength(value, 2, 30)) {
        error = "errors.identity_document_number.between_2_30"
    }

    return error;
}

export const validateJurPersonPost = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    } else if (validators.ValidateLength(value, 2, 30)) {
        error = "errors.person_post.between_2_30"
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)) {
        error = "errors.person_post.only_english_letters"
    }

    return error;
}


export const validateJurAddress = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    }
    else if (validators.ValidateLength(value, 2, 300)) {
        error = "errors.juridical_address.between_2_300"
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value))
    {
        error =  "errors.juridical_address.only_english_letters"
    }

    return error;
}

export const validateJurCompanyName = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    }
    else if (validators.ValidateLength(value, 2, 250)) {
        error = "errors.jur_company_name.between_2_250"
    }else if(
        validators.ValidateCompanyName(value)
    ){
        error =  interpretCompanyNameError(
            validators.ValidateCompanyName(value)
        )
    }

    return error;
}

export const validateTaxDepartment = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    }
    else if (validators.ValidateLength(value, 2, 30)) {
        error = "errors.tax_department.between_2_30"
    } else if (validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)) {
        error = "errors.tax_department.only_english_letters"
    }

    return error;
}

export const validateTaxNumber = (value) => {
    let error = null;

    if (!value) {
        error = 'required';
    }
    else if (validators.ValidateNumber(value)) {
        error = "errors.tax_number.number"
    }
    else if (validators.ValidateLength(value, 2, 300)) {
        error = "errors.tax_number.between_2_100"
    }

    return error;
}

export const validateIndividualUser = (value) => {
    let errors = [];

    let fullNameError = validateFullName(value["full-name"])
    let emailError = validateEmail(value.email)
    let phoneError = validatePhone(value["phone-number"])
    let addressError = validateAddress(value.address)
    let identityDocumentNumberError = validateIdentityDocumentNumber(value["identity-document-number"])

    if (fullNameError) {
        errors.push("errors.alerts.individual_user.username")
    }

    if (emailError) {
        errors.push("errors.alerts.individual_user.email")
    }

    if (phoneError) {
        errors.push("errors.alerts.individual_user.phone")
    }

    if (addressError) {
        errors.push("errors.alerts.individual_user.address")
    }

    if (identityDocumentNumberError) {
        errors.push("errors.alerts.individual_user.identity_number")
    }

    return errors;
}

export const validateLegalUser = (value) => {
    let errors = [];

    let fullNameError = validateFullName(value["full-name"])
    let emailError = validateEmail(value.email)
    let phoneError = validatePhone(value["phone-number"])
    let juridicalAddressError = validateJurAddress(value["juridical-address"])
    let juridicalCompanyError = validateJurCompanyName(value["juridical-company"])
    let taxDepartmentError = validateTaxDepartment(value['tax-department'])
    let taxNumberError = validateTaxNumber(value['tax-number'])
 
    if (fullNameError) {
        errors.push("errors.alerts.legal_user.username")
    }

    if (emailError) {
        errors.push("errors.alerts.legal_user.email")
    }

    if (phoneError) {
        errors.push("errors.alerts.legal_user.phone")
    }

    if (juridicalAddressError) {
        errors.push("errors.alerts.legal_user.juridical_address")
    }

    if(juridicalCompanyError)
    {
        errors.push("errors.alerts.legal_user.juridical_company")
    }

    if(taxDepartmentError)
    {
        errors.push("errors.alerts.legal_user.tax_department")
    }
    if(taxNumberError)
    {
        errors.push("errors.alerts.legal_user.tax_number")
    }
    return errors;
}